module.exports = __webpack_public_path__ + "img/product_82.d02f713.webp";